export const ViewExpendIcon = ({ className }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1742_52787)">
        <path
          d="M13.1328 3.75H16.8828V7.5"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8828 8.75L16.8828 3.75"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.13281 16.25H4.38281V12.5"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.38281 11.25L4.38281 16.25"
          stroke="#070707"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1742_52787">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.632812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
